import { Box } from '@mui/material';
import { FormTitleBox, LoadingSkeleton, ConfirmationDialog, TableBodySkeleton } from '../../../common/components';
import SubcontractorsDataTable from './components/SubcontractorsDataTable';
import SubcontractorsPagination from './components/SubcontractorsPagination';
import SubcontractorDialog from './components/SubcontractorDialog';
import { useSubcontractorsTable } from './hooks/useSubcontractorsTable';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SubcontractorsFilters from './components/SubcontractorsFilters';

const SubcontractorsTable = () => {
  const {
    data,
    isLoading,
    page,
    totalPages,
    totalCount,
    searchTerm,
    dialogOpen,
    editMode,
    selectedSubcontractor,
    countries,
    provinces,
    departments,
    districts,
    handleSearch,
    handlePageChange,
    handleOpenDialog,
    handleCloseDialog,
    handleInputChange,
    handleSelectChange,
    handleSave,
    handleEdit,
    handleDelete,
    deleteConfirmOpen,
    entityToDelete,
    handleConfirmDelete,
    handleCancelDelete,
    rowsPerPage,
    handleRowsPerPageChange,
  } = useSubcontractorsTable();

  return (
    <Box>
      <FormTitleBox
        title="Obra | Seguimiento | Subcontratistas"
        showButton={true}
        buttonText="Agregar Subcontratista"
        buttonIcon={PersonAddIcon}
        onButtonClick={handleOpenDialog}
      />

      <SubcontractorsFilters searchTerm={searchTerm} onSearchChange={handleSearch} />

      <SubcontractorsDataTable
        data={data}
        isLoading={isLoading}
        onEdit={handleEdit}
        onDelete={handleDelete}
        LoadingComponent={TableBodySkeleton}
      />

      <SubcontractorsPagination
        totalPages={totalPages}
        totalCount={totalCount}
        page={page}
        onPageChange={handlePageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <SubcontractorDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        editMode={editMode}
        selectedSubcontractor={selectedSubcontractor}
        onInputChange={handleInputChange}
        onSelectChange={handleSelectChange}
        onSave={handleSave}
        countries={countries}
        provinces={provinces}
        departments={departments}
        districts={districts}
      />

      <ConfirmationDialog
        open={deleteConfirmOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        entityName="subcontratista"
        message={`¿Está seguro que quiere eliminar el subcontratista "${
          entityToDelete?.company || ''
        }" de forma permanente?`}
      />
    </Box>
  );
};

export default SubcontractorsTable;
